import React from "react";
import { useNavigate } from "react-router-dom";

const ICONS = {
  property: "fa-building",
  user: "fa-users",
  partner: "fa-briefcase",
  visit: "fa-user",
  registration: "fa-id-card-o",
  walkin: "fa-map-marker",
  followup: "fa-phone",
  booking: "fa-bookmark",
  ticket: "fa-ticket",
  appointment: "fa-calendar",
  default: "fa-line-chart",
};

const CountBoxCard = (props) => {
  const navigate = useNavigate();
  const {
    navigateLink = "",
    label,
    count = 0,
    loading = false,
    tone = "brand",
    icon = "default",
  } = props;
  const displayCount =
    loading && (count === 0 || count === null || count === undefined)
      ? "—"
      : count > 0
        ? count
        : "00";
  const clickable = Boolean(navigateLink);
  const iconClass = ICONS[icon] || ICONS.default;

  return (
    <div
      className={`justo-dashboard__kpi justo-dashboard__kpi--${tone}${
        clickable ? " is-clickable" : ""
      }`}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={() => {
        if (navigateLink) navigate(navigateLink);
      }}
      onKeyDown={(e) => {
        if (!navigateLink) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigate(navigateLink);
        }
      }}
    >
      <div className="justo-dashboard__kpi-top">
        <span className="justo-dashboard__kpi-icon" aria-hidden="true">
          <i className={`fa ${iconClass}`} />
        </span>
        {clickable ? (
          <span className="justo-dashboard__kpi-go" aria-hidden="true">
            <i className="fa fa-arrow-right" />
          </span>
        ) : null}
      </div>
      <p className="justo-dashboard__kpi-value">{displayCount}</p>
      <p className="justo-dashboard__kpi-label">{label}</p>
    </div>
  );
};

export default CountBoxCard;
